
(function _auGuardCartImages() {
  const SEL = '.cart__image--img[data-au-locked-src]';
  const ATTR = 'data-au-locked-src';
  const BAD = '/uploads/';

  function _fix(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SEL).forEach((img) => {
      if (img.src.indexOf(BAD) !== -1) img.src = img.getAttribute(ATTR);
    });
  }

  const target = document.querySelector('[data-products]') || document.body;

  /* MutationObserver — immediate, zero-latency coverage. */
  const obs = new MutationObserver((mutations) => {
    for (let i = 0, len = mutations.length; i < len; i++) {
      const m = mutations[i];
      if (m.type === 'attributes') {
        const img = m.target;
        if (img.src.indexOf(BAD) !== -1) img.src = img.getAttribute(ATTR);
      } else if (m.type === 'childList') {
        const added = m.addedNodes;
        for (let j = 0, jLen = added.length; j < jLen; j++) {
          const n = added[j];
          if (n.nodeType === 1) _fix(n);
        }
      }
    }
  });
  obs.observe(target, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src'],
  });

  document.addEventListener('cart:updated', () => {
    requestAnimationFrame(() => _fix(target));
    setTimeout(() => _fix(target), 300);
  });
})();

/* ── Cart cache for instant checkout verification ── */
var _auCartCache = { data: null, ts: 0 };
function _auWarmCartCache() {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      _auCartCache.data = cart;
      _auCartCache.ts = Date.now();
    })
    .catch(function () { /* silent – cache stays stale */ });
}
function _auCachedGiftsOnly() {
  var cart = _auCartCache.data;
  if (!cart || !cart.items || !cart.items.length) return false;
  for (var i = 0; i < cart.items.length; i++) {
    var props = cart.items[i].properties || {};
    if (!props._auTierGift && !props._isFreeGift) return false;
  }
  return true;
}

/* ── Block checkout: cart has ONLY free gifts ── */
function _auCartHasOnlyFreeGifts() {
  var box = document.querySelector('[data-products]') || document.querySelector('.cart__items');
  if (!box) return false;
  var lines = box.querySelectorAll('[data-hulkapps-lineitem]');
  if (!lines.length) return false; // empty cart = not "only gifts"
  var hasPaid = false;
  for (var i = 0; i < lines.length; i++) {
    if (!lines[i].classList.contains('cart__item--au-free-gift')) {
      hasPaid = true;
      break;
    }
  }
  return !hasPaid;
}

function _auSyncGiftsOnlyState() {
  var onlyGifts = _auCartHasOnlyFreeGifts();

  /* Toggle disabled class + hard-block on checkout buttons */
  document.querySelectorAll('.cart__checkout').forEach(function (btn) {
    if (onlyGifts) {
      btn.classList.add('cart__checkout--gifts-only');
      btn.style.pointerEvents = 'none';
      btn.setAttribute('disabled', '');
    } else {
      btn.classList.remove('cart__checkout--gifts-only');
      btn.style.pointerEvents = '';
      btn.removeAttribute('disabled');
    }
  });
}

function cartTermsLabelPulse() {
  const _AU_TERMS_SS_KEY = 'au_cart_terms_checked';

  const resetCartCheckoutState = () => {
    /* Restore checkbox state from sessionStorage instead of always unchecking */
    const savedChecked = sessionStorage.getItem(_AU_TERMS_SS_KEY) === '1';

    document.querySelectorAll('.cart__terms-checkbox').forEach((cb) => {
      cb.checked = savedChecked;
    });

    document.querySelectorAll('.cart__terms-label').forEach((lbl) => {
      lbl.classList.remove('cart__checkout--errorPulse');
    });

    document.querySelectorAll('.cart__checkout').forEach((btn) => {
      btn.classList.remove('cart__checkout--loading', 'btn--loading');
      if (btn.dataset.originalHtml) {
        btn.innerHTML = btn.dataset.originalHtml;
      }
      const container = btn.closest('form') || btn.closest('.cart__checkout-wrapper')?.parentNode || document;
      const termsCheckbox = container.querySelector('.cart__terms-checkbox') || document.querySelector('.cart__terms-checkbox');
      const isRequired = btn.getAttribute('data-terms-required') === 'true' || Boolean(termsCheckbox);

      if (isRequired && (!termsCheckbox || !termsCheckbox.checked)) {
        btn.classList.add('cart__checkout--disabled');
      } else if (termsCheckbox && termsCheckbox.checked) {
        btn.classList.remove('cart__checkout--disabled');
      }
    });
  };

  if (!window.__auTermsPageShowBound) {
    window.__auTermsPageShowBound = true;

    const runReset = () => {
      resetCartCheckoutState();
      setTimeout(resetCartCheckoutState, 50);
      setTimeout(resetCartCheckoutState, 300);
    };

    window.addEventListener('pageshow', runReset);
    window.addEventListener('popstate', runReset);

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.cart__checkout');
      if (!btn) return;

      /* ── Always block first — verify before allowing ── */
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      /* Quick-reject: cart is mid-processing */
      if (auProcOn) return;

      /* Quick-reject: DOM says gifts-only */
      if (_auCartHasOnlyFreeGifts()) return;

      /* Terms checkbox check */
      const container = btn.closest('form') || btn.closest('.cart__checkout-wrapper')?.parentNode || document;
      const termsCheckbox = container.querySelector('.cart__terms-checkbox') || document.querySelector('.cart__terms-checkbox');
      const termsLabel = container.querySelector('.cart__terms-label') || document.querySelector('.cart__terms-label');
      const termsRequired = btn.getAttribute('data-terms-required') === 'true' || Boolean(termsCheckbox);

      if (termsRequired && termsCheckbox && !termsCheckbox.checked) {
        if (termsLabel) {
          termsLabel.classList.add('cart__checkout--errorPulse');
        }
        return;
      }

      /* Show loading state */
      if (!btn.dataset.originalHtml) {
        btn.dataset.originalHtml = btn.innerHTML;
      }
      btn.classList.remove('cart__checkout--disabled');
      btn.classList.add('cart__checkout--loading', 'btn--loading');
      const spinnerSvg = '<svg class="cart__checkout-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width: 18px; height: 18px; display: inline-block; vertical-align: middle; margin-right: 8px; animation: cartSpinnerRotate 0.8s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.25" fill="none"></circle><path d="M12 2 a10 10 0 0 1 10 10" stroke="currentColor" fill="none"></path></svg>';
      btn.innerHTML = `${spinnerSvg}<span>Checking out</span>`;

      /* ── Instant cached verification (warm cache strategy) ── */
      var _restoreBtn = function () {
        btn.classList.remove('cart__checkout--loading', 'btn--loading');
        if (btn.dataset.originalHtml) btn.innerHTML = btn.dataset.originalHtml;
      };
      var cacheAge = Date.now() - _auCartCache.ts;
      var useCached = _auCartCache.data && cacheAge < 10000; /* 10 s staleness */

      if (useCached) {
        if (_auCachedGiftsOnly()) {
          /* Cached data says gifts-only — block */
          _auSyncGiftsOnlyState();
          _restoreBtn();
          return;
        }
        /* Cached data says valid cart — navigate immediately */
        window.location.href = '/checkout';
        return;
      }

      /* Cache is stale/missing — quick fetch with 500 ms timeout */
      var _abortCtl = typeof AbortController === 'function' ? new AbortController() : null;
      var _navDone = false;
      var _timeoutId = setTimeout(function () {
        if (_navDone) return;
        _navDone = true;
        if (_abortCtl) try { _abortCtl.abort(); } catch (_) {}
        window.location.href = '/checkout';
      }, 500);

      fetch('/cart.js', {
        credentials: 'same-origin',
        signal: _abortCtl ? _abortCtl.signal : undefined
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          clearTimeout(_timeoutId);
          if (_navDone) return;
          /* Update cache */
          _auCartCache.data = cart;
          _auCartCache.ts = Date.now();
          /* Check if ALL items are free gifts */
          var items = cart.items || [];
          var hasPaid = false;
          for (var i = 0; i < items.length; i++) {
            var props = items[i].properties || {};
            var isGift = props._auTierGift || props._isFreeGift;
            if (!isGift) { hasPaid = true; break; }
          }
          if (!hasPaid && items.length > 0) {
            _auSyncGiftsOnlyState();
            _restoreBtn();
            return;
          }
          _navDone = true;
          window.location.href = '/checkout';
        })
        .catch(function () {
          clearTimeout(_timeoutId);
          if (_navDone) return;
          _navDone = true;
          window.location.href = '/checkout';
        });
    }, true); /* ← capturing phase */

    const handleCheckboxToggle = (cb) => {
      const isChecked = cb.checked;

      /* Persist checkbox state in sessionStorage */
      sessionStorage.setItem(_AU_TERMS_SS_KEY, isChecked ? '1' : '0');

      /* Sync all checkboxes (drawer + page may both exist) */
      document.querySelectorAll('.cart__terms-checkbox').forEach((otherCb) => {
        if (otherCb !== cb) otherCb.checked = isChecked;
      });

      document.querySelectorAll('.cart__terms-label').forEach((lbl) => {
        if (isChecked) lbl.classList.remove('cart__checkout--errorPulse');
      });
      document.querySelectorAll('.cart__checkout').forEach((checkoutBtn) => {
        if (isChecked) {
          checkoutBtn.classList.remove('cart__checkout--disabled');
        } else {
          checkoutBtn.classList.add('cart__checkout--disabled');
        }
      });
    };

    document.addEventListener('change', function (e) {
      const cb = e.target.closest('.cart__terms-checkbox');
      if (cb) handleCheckboxToggle(cb);
    });

    document.addEventListener('input', function (e) {
      const cb = e.target.closest('.cart__terms-checkbox');
      if (cb) handleCheckboxToggle(cb);
    });
  }

  resetCartCheckoutState();
}

function announcementSlider() {
  const root = document.querySelector('[data-announcement-slider]') || document.querySelector('.cart-announcement-slider');
  const slider = root?.querySelector('.cart-announcement-slider__list');
  const slides = root?.querySelectorAll('.cart-announcement-slider__item');
  const totalSlides = slides?.length ?? 0;

  if (!root || !slider || totalSlides <= 1) return;
  if (root.dataset.announcementInit === 'true') return;
  root.dataset.announcementInit = 'true';

  const slideMsRaw = getComputedStyle(root).getPropertyValue('--announcement-slide-ms').trim();
  const slideMs = Math.max(1, Math.round(parseFloat(slideMsRaw)) || 1000);
  const cActive = 'cart-announcement-slider__item--active';
  const cNoMotion = 'cart-announcement-slider__list--no-motion';
  const cDragging = 'cart-announcement-slider--dragging';

  slider.appendChild(slides[0].cloneNode(true));
  const items = slider.querySelectorAll('.cart-announcement-slider__item');
  const n = totalSlides;

  let idx = 0;
  let dragPx = 0;
  let startX = 0;
  let ptrId = null;
  let autoplayId = null;

  let wrapCtl = null;
  let slideW = 1;
  let moveRaf = 0;
  let dragAnchorIdx = 0;

  const measure = () => {
    const trackW = slider.getBoundingClientRect().width;
    const itemW = items[0]?.getBoundingClientRect().width ?? 0;
    let w = 0;
    if (itemW > 0.5 && trackW > 0.5) {
      w = Math.round(((itemW + trackW) / 2) * 1000) / 1000;
    } else if (trackW > 0.5) {
      w = trackW;
    } else if (itemW > 0.5) {
      w = itemW;
    } else {
      w = root.clientWidth || 1;
    }
    slideW = Math.max(1, w);
  };

  const applyTx = () => {
    root.style.setProperty('--announcement-tx', `${-idx * slideW + dragPx}px`);
  };

  const clampDrag = (raw) => {
    if (dragAnchorIdx >= n) return 0;
    if (dragAnchorIdx <= 0) {
      if (raw <= 0) return raw;
      const lim = slideW * 0.12;
      return lim * Math.tanh(raw / lim);
    }
    return raw;
  };

  const cancelMoveRaf = () => {
    if (moveRaf) {
      cancelAnimationFrame(moveRaf);
      moveRaf = 0;
    }
  };

  const scheduleApply = () => {
    if (moveRaf) return;
    moveRaf = requestAnimationFrame(() => {
      moveRaf = 0;
      applyTx();
    });
  };

  const setActive = (i) => {
    for (let j = 0; j < items.length; j++) {
      items[j].classList.toggle(cActive, j === i);
    }
  };

  const clearWrapReset = () => {
    if (!wrapCtl) return;
    clearTimeout(wrapCtl.tid);
    slider.removeEventListener('transitionend', wrapCtl.onEnd);
    wrapCtl = null;
  };


  const snapToRealFirstSlide = () => {
    slider.classList.add(cNoMotion);
    idx = 0;
    dragPx = 0;
    setActive(0);
    applyTx();
    void slider.offsetHeight;
    requestAnimationFrame(() => {
      slider.classList.remove(cNoMotion);
    });
  };

  const scheduleClone = () => {
    clearWrapReset();

    let finished = false;
    const finish = () => {
      if (finished) return;
      if (!wrapCtl) return;
      finished = true;
      clearTimeout(wrapCtl.tid);
      slider.removeEventListener('transitionend', wrapCtl.onEnd);
      wrapCtl = null;
      snapToRealFirstSlide();
    };

    const isTransformEnd = (e) => {
      if (e.target !== slider) return false;
      const p = e.propertyName;
      return p === 'transform' || p === '-webkit-transform';
    };

    const onEnd = (e) => {
      if (!isTransformEnd(e)) return;
      finish();
    };

    wrapCtl = {
      onEnd,
      tid: setTimeout(finish, slideMs + 450),
    };
    slider.addEventListener('transitionend', onEnd);

    requestAnimationFrame(() => {
      if (finished || !wrapCtl) return;
      const anims = typeof slider.getAnimations === 'function' ? slider.getAnimations({ subtree: false }) : [];
      const tr = anims.find(
        (a) =>
          typeof CSSTransition !== 'undefined' &&
          a instanceof CSSTransition &&
          (a.transitionProperty === 'transform' || a.transitionProperty === '-webkit-transform')
      );
      if (tr?.finished) {
        tr.finished.then(() => finish()).catch(() => { });
      }
    });
  };

  const restartAutoplay = () => {
    if (autoplayId) clearInterval(autoplayId);
    autoplayId = setInterval(goNext, 5000);
  };


  const crossfade = (prevI, incoming) => {
    queueMicrotask(() => {
      items[prevI]?.classList.remove(cActive);
      incoming?.classList.add(cActive);
    });
  };

  function goNext() {
    if (idx >= n) return;
    if (slider.classList.contains(cNoMotion)) return;
    clearWrapReset();
    const prevI = idx;
    idx++;
    measure();
    applyTx();
    crossfade(prevI, items[idx]);
    if (idx === n) scheduleClone();
  }

  function goPrev() {
    if (idx <= 0) return;
    if (slider.classList.contains(cNoMotion)) return;
    clearWrapReset();
    const prevI = idx;
    idx--;
    measure();
    applyTx();
    crossfade(prevI, items[idx]);
  }

  root.classList.add('cart-announcement-slider--initialized');
  setActive(0);
  measure();
  applyTx();

  new ResizeObserver(() => {
    if (root.classList.contains(cDragging)) return;
    measure();
    slider.classList.add(cNoMotion);
    applyTx();
    void slider.offsetHeight;
    slider.classList.remove(cNoMotion);
  }).observe(root);

  const swipeTh = () => Math.max(28, slideW * 0.16);

  const endDrag = (e) => {
    if (!root.classList.contains(cDragging)) return;
    if (ptrId !== null && e.pointerId !== ptrId) return;
    cancelMoveRaf();
    const th = swipeTh();
    const d = dragPx;
    dragPx = 0;
    const capId = ptrId;
    ptrId = null;
    root.classList.remove(cDragging);
    try {
      if (capId != null && root.hasPointerCapture(capId)) root.releasePointerCapture(capId);
    } catch (_) { }
    if (d < -th && idx < n) goNext();
    else if (d > th && idx > 0 && dragAnchorIdx > 0) goPrev();
    else applyTx();
    restartAutoplay();
  };

  const onDown = (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (idx >= n || ptrId !== null) return;
    ptrId = e.pointerId;
    startX = e.clientX;
    dragPx = 0;
    dragAnchorIdx = idx;
    measure();
    root.classList.add(cDragging);
    try {
      root.setPointerCapture(e.pointerId);
    } catch (_) { }
    clearWrapReset();
    if (autoplayId) {
      clearInterval(autoplayId);
      autoplayId = null;
    }
    applyTx();
  };

  const onMove = (e) => {
    if (e.pointerId !== ptrId || !root.classList.contains(cDragging)) return;
    dragPx = clampDrag(e.clientX - startX);
    scheduleApply();
  };

  root.addEventListener('pointerdown', onDown);
  root.addEventListener('pointermove', onMove, { passive: true });
  root.addEventListener('pointerup', endDrag);
  root.addEventListener('pointercancel', endDrag);
  root.addEventListener('lostpointercapture', endDrag);

  document.addEventListener('drawerOpen', () => {
    if (root.classList.contains(cDragging)) return;
    measure();
    applyTx();
  });

  restartAutoplay();
}

const openBundleKeys = new Set();

function getBundleKey(button) {
  const item = button.closest('.cart__item, [data-variant-id], [data-key], [data-hulkapps-lineitem]');
  if (!item) return null;
  const variantId = item.getAttribute('data-variant-id');
  if (variantId) return 'vid_' + variantId;
  const key = item.getAttribute('data-key');
  if (key) return 'key_' + key.split(':')[0];
  const title = item.querySelector('.cart__item-name, .cart__item-title')?.textContent?.trim();
  if (title) return 'title_' + title;
  return null;
}

function bundleProductDDL(root = document) {
  if (!window.__auBundleToggleBound) {
    window.__auBundleToggleBound = true;
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.bundle-toggle');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      const container = button.closest('.bundle-wrapper') || button.parentNode;
      const list = container ? container.querySelector('.bundle-items') : button.nextElementSibling;
      if (!list) return;

      button.classList.toggle('show-bundle');
      const open = button.classList.contains('show-bundle');
      const key = getBundleKey(button);
      if (key) {
        if (open) openBundleKeys.add(key);
        else openBundleKeys.delete(key);
      }

      const label = button.querySelector('.bundle-toggle-text');
      const n = list.querySelectorAll('.bundle-item').length || list.children.length;

      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) {
        label.textContent = open ? `Hide ${n} items` : `Show ${n} items`;
      }
    });
  }

  root.querySelectorAll('.bundle-toggle').forEach((button) => {
    const container = button.closest('.bundle-wrapper') || button.parentNode;
    const list = container ? container.querySelector('.bundle-items') : button.nextElementSibling;
    if (!list) return;

    const key = getBundleKey(button);
    if (key && openBundleKeys.has(key)) {
      button.classList.add('no-anim', 'show-bundle');
      requestAnimationFrame(() => {
        button.classList.remove('no-anim');
      });
    }

    const label = button.querySelector('.bundle-toggle-text');
    const open = button.classList.contains('show-bundle');
    const n = list.querySelectorAll('.bundle-item').length || list.children.length;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? `Hide ${n} items` : `Show ${n} items`;
  });
}

function syncSubtotal() { }

let auProcOn = false;
let auProcTid = 0;
function setProcessingState(on) {
  if (auProcOn === on) return;
  auProcOn = on;
  /* Hard-block checkout buttons at the browser level during processing */
  document.querySelectorAll('.cart__checkout').forEach(function (btn) {
    if (on) {
      btn.style.pointerEvents = 'none';
      btn.setAttribute('disabled', '');
    } else {
      btn.style.pointerEvents = '';
      btn.removeAttribute('disabled');
    }
  });
  /* When turning OFF processing, immediately re-check gifts-only state
     so buttons stay locked if the cart now has only free gifts */
  if (!on) {
    _auSyncGiftsOnlyState();
  }
}
function beginProcessing() {
  clearTimeout(auProcTid);
  setProcessingState(true);
  auProcTid = setTimeout(() => {
    auProcTid = 0;
    setProcessingState(false);
  }, 6000);
}

/* ── Capturing-phase form submit guard ── */
if (!window.__auCheckoutSubmitGuard) {
  window.__auCheckoutSubmitGuard = true;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    /* Only intercept checkout forms (not cart update/delete forms) */
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/checkout') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }, true); /* ← capturing phase */
}

function endProcessing() {
  if (!auProcOn) return;

  if (auFgBusy) return;
  clearTimeout(auProcTid);
  auProcTid = setTimeout(() => {
    auProcTid = 0;
    setProcessingState(false);
  }, 80);
}

/* moneyToCents – shared by recompute() and patchCartMarkupStrikethrough() */
function _auMoneyToCents(text) {
  const m = String(text || '').match(/[\d,]+\.?\d*/);
  if (!m) return null;
  const n = parseFloat(m[0].replace(/,/g, ''));
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

(function () {
  const FORM_SEL =
    '#CartDrawerForm, #CartPageForm, form[data-location="drawer"], form[data-location="page"], form[data-location="cart"]';
  const pending = new Set();
  let raf = 0;

  const moneyToCents = _auMoneyToCents;


  function updateMotivationalBar(form, cents) {
    const bar = form.querySelector('#motivational-bar-wrapper');
    if (!bar) return;

    const t1 = parseFloat(bar.dataset.t1 || '0') * 100;
    const t2 = parseFloat(bar.dataset.t2 || '0') * 100;
    const t3 = parseFloat(bar.dataset.t3 || '0') * 100;
    const t4 = parseFloat(bar.dataset.t4 || '0') * 100;

    const enabledTiers = [];
    if (t1 > 0) enabledTiers.push(t1);
    if (t2 > 0) enabledTiers.push(t2);
    if (t3 > 0) enabledTiers.push(t3);
    if (t4 > 0) enabledTiers.push(t4);

    const tierCount = enabledTiers.length;
    let barFillPct = 0;

    if (tierCount > 0) {
      const segPct = 100.0 / tierCount;
      const halfSeg = segPct / 2.0;
      let prevTierCents = 0;
      let prevTierVisual = 0;
      let fillDone = false;
      let slot = 0;

      for (let i = 0; i < tierCount; i++) {
        const tCents = enabledTiers[i];
        if (fillDone === false) {
          slot += 1;
          const tierVisual = segPct * slot - halfSeg;
          if (cents >= tCents) {
            prevTierCents = tCents;
            prevTierVisual = tierVisual;
          } else {
            const segCents = tCents - prevTierCents;
            const spent = cents - prevTierCents;
            const segRatio = Math.min(spent / segCents, 1.0);
            const segVisual = tierVisual - prevTierVisual;
            barFillPct = segRatio * segVisual + prevTierVisual;
            fillDone = true;
          }
        }
      }
      if (fillDone === false) {
        barFillPct = 100;
      }
    }

    // Update fill element width with smooth animation
    const fillEl = bar.querySelector('.motivational-bar__fill');
    if (fillEl) {
      const target = `${Math.min(barFillPct, 100)}%`;
      const from = _lastFillPct !== null ? _lastFillPct : '0%';
      fillEl.style.transition = 'none';
      fillEl.style.width = from;
      void fillEl.offsetWidth;
      fillEl.style.transition = '';
      fillEl.style.width = target;
      _lastFillPct = target;
    }

    // Update block badges active class
    let currentSum = 0;
    let lastConditionMet = true;
    const blocks = bar.querySelectorAll('.motivational-bar__block');

    blocks.forEach((block, idx) => {
      if (idx >= tierCount) return;
      const tCents = enabledTiers[idx];
      let progress = 0;
      const prevCents = idx === 0 ? 0 : enabledTiers[idx - 1];

      if (idx === 0 || lastConditionMet) {
        const offsetPrice = cents - prevCents;
        const offsetMinimum = tCents - prevCents;
        progress = Math.min(Math.max(offsetPrice / offsetMinimum, 0), 1) * 100;
      }

      const badge = block.querySelector('.motivational-bar__block-badge');
      if (badge) {
        if (progress >= 100) {
          badge.classList.add('motivational-bar__block-badge--active');
          lastConditionMet = true;
          currentSum = tCents;
        } else {
          badge.classList.remove('motivational-bar__block-badge--active');
          lastConditionMet = false;
        }
      }
    });

    // Update text messages
    let unlockedText = '';
    let neededText = '';
    let neededAmountInCents = 0;
    let nextTierProduct = '';

    lastConditionMet = true;
    for (let idx = 0; idx < tierCount; idx++) {
      const tCents = enabledTiers[idx];
      const tNum = idx + 1;
      const tUnlocked = bar.getAttribute(`data-t${tNum}-unlocked`) || '';
      const tNeeded = bar.getAttribute(`data-t${tNum}-needed`) || '';
      const tProduct = bar.getAttribute(`data-t${tNum}-product`) || '';

      let progress = 0;
      const prevCents = idx === 0 ? 0 : enabledTiers[idx - 1];
      if (idx === 0 || lastConditionMet) {
        const offsetPrice = cents - prevCents;
        const offsetMinimum = tCents - prevCents;
        progress = Math.min(Math.max(offsetPrice / offsetMinimum, 0), 1) * 100;
      }

      if (progress >= 100) {
        lastConditionMet = true;
        unlockedText = tUnlocked;
      } else {
        if (lastConditionMet) {
          neededText = tNeeded;
          neededAmountInCents = tCents - cents;
          nextTierProduct = tProduct;
        }
        lastConditionMet = false;
      }
    }

    const textEl = bar.querySelector('.motivational-bar__text');
    if (textEl) {
      let finalHtml = unlockedText;
      if (neededText) {
        const moneyFmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '£{{amount}}';
        const formatted = window.theme.Currency ? window.theme.Currency.formatMoney(neededAmountInCents, moneyFmt) : `£${(neededAmountInCents / 100).toFixed(2)}`;
        const neededAmountSpan = `<span>${formatted.replace(/\s/g, '')}</span>`;
        let textWithAmount = neededText.replace('XY', neededAmountSpan);
        const showProduct = bar.dataset.giftInProgress === 'true';
        if (showProduct && nextTierProduct) {
          textWithAmount += ' ' + nextTierProduct;
        }
        finalHtml += (finalHtml ? ' ' : '') + textWithAmount;
      }
      textEl.innerHTML = finalHtml;
    }
  }

  function recompute(form, isFinal) {
    const products = form.querySelector('[data-products]');
    if (!products) return;
    const fmt = window.theme && window.theme.Currency && window.theme.Currency.formatMoney;
    if (typeof fmt !== 'function') return;
    const moneyFmt = window.theme.settings && window.theme.settings.moneyFormat;


    let cents = 0;
    let origCents = 0;
    let lineItemsCounted = 0;
    products.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
      const isGift = line.classList.contains('cart__item--au-free-gift');
      const qi = line.querySelector('input[name="updates[]"]');
      const qty = qi ? parseInt(qi.value || '0', 10) : 1;
      if (!Number.isFinite(qty) || qty < 1) return;

      let priceSpan = null;
      line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
        if (priceSpan || s.closest('.cart__price--strikethrough')) return;
        priceSpan = s;
      });
      if (!priceSpan) return;
      const unit = moneyToCents(priceSpan.textContent);
      if (unit === null) return;
      cents += unit * qty;
      lineItemsCounted++;

      {
        let origUnit = unit;
        const strikeSpan = line.querySelector(
          '.cart__price--strikethrough [data-hulkapps-ci-price], .cart__price--strikethrough [data-au-ci-price]',
        );
        if (strikeSpan) {
          const strikeVal = moneyToCents(strikeSpan.textContent);
          if (strikeVal !== null && strikeVal > origUnit) origUnit = strikeVal;
        }
        origCents += origUnit * qty;
      }
    });

    updateMotivationalBar(form, cents);

    if (lineItemsCounted > 0) {
      const box =
        form.querySelector('[data-hulkapps-cart-total]') ||
        form.querySelector('[data-subtotal]');
      if (box) {
        let target = box.querySelector('.bcpo-cart-original-total');
        if (!target) {

          box.innerHTML = '';
          target = document.createElement('span');
          target.className = 'bcpo-cart-original-total';
          box.appendChild(target);
        }
        const formatted = fmt.call(window.theme.Currency, cents, moneyFmt);
        if (target.textContent !== formatted) target.textContent = formatted;
      }
    }


    const origEl = form.querySelector('[data-subtotal-original]');
    if (origEl) {
      if (origCents > 0 && origCents > cents) {
        const preFormatted = fmt.call(window.theme.Currency, origCents, moneyFmt);
        if (origEl.innerHTML !== preFormatted) origEl.innerHTML = preFormatted;
        if (origEl.classList.contains('hide')) origEl.classList.remove('hide');
        if (origEl.getAttribute('aria-hidden') !== 'false') {
          origEl.setAttribute('aria-hidden', 'false');
        }
      } else if (isFinal && lineItemsCounted > 0) {
        if (origEl.innerHTML !== '') origEl.innerHTML = '';
        if (!origEl.classList.contains('hide')) origEl.classList.add('hide');
        if (origEl.getAttribute('aria-hidden') !== 'true') {
          origEl.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }


  function schedule(form) {
    pending.add(form);
    if (!raf) {
      raf = requestAnimationFrame(() => {
        raf = 0;
        pending.forEach((f) => recompute(f, true));
        pending.clear();
      });
    }
  }

  function wire() {
    document.querySelectorAll(FORM_SEL).forEach((form) => {
      const products = form.querySelector('[data-products]');
      if (!products) return;

      if (form.__auSubProducts !== products) {
        form.__auSubProducts = products;
        new MutationObserver(() => schedule(form)).observe(products, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
      schedule(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  document.addEventListener('cart:updated', wire);
})();

let _auMarkupAbort = null;
function _auAbortMarkup() {
  if (!_auMarkupAbort) return;
  try { _auMarkupAbort.abort(); } catch (_) { }
  _auMarkupAbort = null;
}
(function patchCartMarkup() {
  const t = window.theme;
  if (!t || !t.cart || typeof t.cart.getCartProductMarkup !== 'function' || !t.routes) {
    setTimeout(patchCartMarkup, 50);
    return;
  }
  if (t.cart.__auPatched) return;
  t.cart.__auPatched = true;

  t.cart.getCartProductMarkup = function () {

    _auAbortMarkup();
    const aborter = new AbortController();
    _auMarkupAbort = aborter;

    let url = '' + t.routes.cartPage + '?t=' + Date.now();
    url += url.indexOf('?') === -1 ? '?view=ajax' : '&view=ajax';

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      signal: aborter.signal,
    })
      .then((r) => {
        if (aborter.signal.aborted) {



          return new Promise(() => { });
        }
        return r.text();
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') {

          return new Promise(() => { });
        }
        throw err;
      })
      .finally(() => {

        if (_auMarkupAbort === aborter) _auMarkupAbort = null;
      });
  };
})();

(function patchCartMarkupStrikethrough() {
  const proto = window.theme && window.theme.CartForm && window.theme.CartForm.prototype;
  if (!proto || typeof proto.cartMarkup !== 'function') {
    setTimeout(patchCartMarkupStrikethrough, 50);
    return;
  }
  if (proto.__auStrikePatched) return;
  proto.__auStrikePatched = true;

  const orig = proto.cartMarkup;
  proto.cartMarkup = function (html) {
    const result = orig.apply(this, arguments);

    const form = this.form;
    const origEl = form && form.querySelector('[data-subtotal-original]');
    if (!origEl) return result;

    const itemsBox = form.querySelector('.cart__items');
    if (!itemsBox) return result;

    const products = form.querySelector('[data-products]');
    let domOK = false;
    let cents = 0;
    let origCents = 0;
    if (products) {
      products.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
        const isGift = line.classList.contains('cart__item--au-free-gift');
        const qi = line.querySelector('input[name="updates[]"]');
        const qty = qi ? parseInt(qi.value || '0', 10) : 1;
        if (!Number.isFinite(qty) || qty < 1) return;

        let priceSpan = null;
        line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
          if (priceSpan || s.closest('.cart__price--strikethrough')) return;
          priceSpan = s;
        });
        if (!priceSpan) return;
        const unit = _auMoneyToCents(priceSpan.textContent);
        if (unit === null) return;
        cents += unit * qty;
        domOK = true;

        /* All lines – including free gifts – contribute to strikethrough */
        {
          let origUnit = unit;
          const strikeSpan = line.querySelector(
            '.cart__price--strikethrough [data-hulkapps-ci-price], .cart__price--strikethrough [data-au-ci-price]',
          );
          if (strikeSpan) {
            const strikeVal = _auMoneyToCents(strikeSpan.textContent);
            if (strikeVal !== null && strikeVal > origUnit) origUnit = strikeVal;
          }
          origCents += origUnit * qty;
        }
      });
    }

    if (domOK) {
      if (origCents > 0 && origCents > cents) {
        origEl.innerHTML = theme.Currency.formatMoney(origCents, theme.settings.moneyFormat);
        origEl.classList.remove('hide');
        origEl.setAttribute('aria-hidden', 'false');
      } else {
        origEl.innerHTML = '';
        origEl.classList.add('hide');
        origEl.setAttribute('aria-hidden', 'true');
      }
    } else {
      /* Fallback: use data-attributes when DOM is not ready */
      const pre = parseInt(itemsBox.getAttribute('data-cart-original-subtotal') || '', 10);
      const paid = parseInt(itemsBox.getAttribute('data-cart-paid-subtotal') || '', 10);
      if (Number.isFinite(pre) && pre > 0 && Number.isFinite(paid) && paid > 0 && pre > paid) {
        origEl.innerHTML = theme.Currency.formatMoney(pre, theme.settings.moneyFormat);
        origEl.classList.remove('hide');
        origEl.setAttribute('aria-hidden', 'false');
      } else {
        origEl.innerHTML = '';
        origEl.classList.add('hide');
        origEl.setAttribute('aria-hidden', 'true');
      }
    }

    return result;
  };
})();

async function autoFreeGiftsFresh() {
  try {
    const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) { return autoFreeGifts(); }
    const cart = await res.json();
    return autoFreeGifts(cart);
  } catch (_) {
    return autoFreeGifts();
  }
}

let auFgBusy = false;
let _auFgPending = false;          /* truthy = a re-check is queued while busy */
async function autoFreeGifts(providedCart) {
  if (auFgBusy) { _auFgPending = true; return; }
  auFgBusy = true;
  window.__AU_IS_BACKGROUND_CART_OP__ = true;
  let didWork = false;
  try {
    const node = document.querySelector('[data-au-free-gift-tiers]');
    if (!node) return;
    let tiers;
    try { tiers = JSON.parse((node.textContent || '[]').trim() || '[]'); } catch { return; }
    if (!Array.isArray(tiers) || !tiers.length) return;

    const isGift = (it) => {
      const p = it.properties || {};
      return p._auTierGift === '1' || p._auTierGift === true || p._isFreeGift === 'true' || p._isFreeGift === true;
    };

    let paid = 0;
    let giftLines = [];
    let themeGiftVids = new Set();
    let hasPaidItems = false;
    const box = document.querySelector('.cart__items');

    if (box) {
      box.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
        const vid = Number(line.dataset.variantId || '');
        const key = line.dataset.key || line.getAttribute('data-key') || '';
        const isGiftLine = line.classList.contains('cart__item--au-free-gift');
        if (isGiftLine) {
          if (vid) {
            giftLines.push({ vid, key });
            themeGiftVids.add(vid);
          }
          return;
        }

        let priceSpan = null;
        line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
          if (priceSpan || s.closest('.cart__price--strikethrough')) return;
          priceSpan = s;
        });
        if (!priceSpan) return;
        const unit = _auMoneyToCents(priceSpan.textContent);
        if (unit === null) return;

        const qi = line.querySelector('input[name="updates[]"]');
        const qty = qi ? parseInt(qi.value || '0', 10) : 1;
        paid += unit * (Number.isFinite(qty) && qty > 0 ? qty : 1);
        hasPaidItems = true;
      });

      const subtotalAttr = Number(box.dataset.cartSubtotal || box.getAttribute('data-cart-subtotal'));
      if (Number.isFinite(subtotalAttr) && subtotalAttr >= 0) {
        paid = Math.min(paid, subtotalAttr);
      }
    } else if (providedCart && Array.isArray(providedCart.items)) {
      paid = Number(providedCart.total_price) || 0;
      for (const it of providedCart.items) {
        const v = Number(it.variant_id);
        if (isGift(it)) {
          giftLines.push({ vid: v, key: it.key });
          if (v) themeGiftVids.add(v);
        } else {
          hasPaidItems = true;
        }
      }
    }

    const wanted = new Set();
    const toAdd = [];
    if (paid > 0 && hasPaidItems) {
      for (const t of tiers) {
        const vid = Number(t?.variant_id);
        const min = Number(t?.min);
        if (!vid || !Number.isFinite(min) || paid < min) continue;
        if (t && t.available === false) continue;
        if (wanted.has(vid)) continue;
        wanted.add(vid);
        if (!themeGiftVids.has(vid)) {
          toAdd.push({
            id: vid,
            quantity: 1,
            properties: { _isFreeGift: 'true', _auTierGift: '1' },
          });
        }
      }
    }

    const toRemoveKeys = [];
    const keptGiftVid = new Set();
    for (const { vid, key } of giftLines) {
      if (!wanted.has(vid) || keptGiftVid.has(vid)) {
        if (key) toRemoveKeys.push(key);
        else if (vid) toRemoveKeys.push(String(vid));
      } else {
        keptGiftVid.add(vid);
      }
    }

    if (!toAdd.length && !toRemoveKeys.length) return;

    didWork = true;
    beginProcessing();
    _auAbortMarkup();

    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    if (toRemoveKeys.length) {
      const updates = {};
      toRemoveKeys.forEach((k) => { updates[k] = 0; });
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ updates }),
        });
      } catch (_) {
        await Promise.allSettled(
          toRemoveKeys.map((id) =>
            fetch('/cart/change.js', { method: 'POST', headers, body: JSON.stringify({ id, quantity: 0 }) })
          )
        );
      }
    }

    if (toAdd.length) {
      await Promise.allSettled(
        toAdd.map((item) =>
          fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify(item) })
        )
      );
    }
  } finally {
    auFgBusy = false;
    window.__AU_IS_BACKGROUND_CART_OP__ = false;
    document.body.classList.add('au-gifts-validated');
    if (didWork) {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    if (_auFgPending) {
      _auFgPending = false;
      autoFreeGifts();
    }
  }
}

let _lastFillPct = null; /* used by updateMotivationalBar() for smooth fill transitions */

let _auSafetyTid = 0;
function _auClearActionLock() {

  document.querySelectorAll('.js-qty__wrapper.is-loading').forEach((el) => {
    el.classList.remove('is-loading');
  });
  document.querySelectorAll('.js-qty__wrapper.is-locked').forEach((el) => {
    el.classList.remove('is-locked');
  });
  document.querySelectorAll('.js-qty__adjust.is-acting, .js-qty__adjust.is-removing').forEach((el) => {
    el.classList.remove('is-acting', 'is-removing');
    el.removeAttribute('aria-busy');
  });

  const cartItems = document.querySelector('.cart__items');
  if (cartItems) {
    cartItems.removeAttribute('aria-busy');
    cartItems.classList.remove('is-updating');
  }

  endProcessing();
}
function _auScheduleSafety() {
  _auCancelSafety();
  _auSafetyTid = setTimeout(() => {
    _auClearActionLock();
  }, 4000);
}
function _auCancelSafety() {
  if (!_auSafetyTid) return;
  clearTimeout(_auSafetyTid);
  _auSafetyTid = 0;
}

function wireCart() {
  if (window.__auCartWired) return;
  window.__auCartWired = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.js-qty__adjust, .js-qty__adjust--remove');
    if (!btn || !btn.closest('[data-products]')) return;

    const line = btn.closest('[data-hulkapps-lineitem]') || btn.closest('.cart__item');
    const isRemove = btn.classList.contains('js-qty__adjust--remove');
    const isMinus = btn.matches('.js-qty__adjust--minus');

    if (line && (isRemove || isMinus)) {
      try {
        let currentSubtotal = 0;
        const box = document.querySelector('.cart__items');
        if (box) {
          box.querySelectorAll('[data-hulkapps-lineitem]').forEach((item) => {
            if (item.classList.contains('cart__item--au-free-gift')) return;
            let priceSpan = null;
            item.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
              if (priceSpan || s.closest('.cart__price--strikethrough')) return;
              priceSpan = s;
            });
            if (!priceSpan) return;
            const unit = _auMoneyToCents(priceSpan.textContent) || 0;
            const qi = item.querySelector('input[name="updates[]"]');
            let qty = qi ? parseInt(qi.value || '0', 10) : 1;

            if (item === line) {
              if (isRemove) qty = 0;
              else if (isMinus) qty = Math.max(0, qty - 1);
            }
            currentSubtotal += unit * qty;
          });

          const node = document.querySelector('[data-au-free-gift-tiers]');
          if (node) {
            const tiers = JSON.parse((node.textContent || '[]').trim() || '[]');
            if (Array.isArray(tiers) && tiers.length) {
              const wantedVids = new Set();
              tiers.forEach((t) => {
                const thresholdCents = Math.round((Number(t.threshold) || 0) * 100);
                if (currentSubtotal >= thresholdCents && t.variant_id) {
                  wantedVids.add(Number(t.variant_id));
                }
              });

              box.querySelectorAll('.cart__item--au-free-gift').forEach((giftLine) => {
                const vid = Number(giftLine.dataset.variantId || '');
                if (vid && !wantedVids.has(vid)) {
                  giftLine.style.transition = 'opacity 0.15s ease';
                  giftLine.style.opacity = '0.2';
                  giftLine.style.pointerEvents = 'none';
                }
              });
            }
          }
        }
      } catch (_) { }
    }

    beginProcessing();
    if (btn.classList.contains('js-qty__adjust--remove')) {
      btn.classList.add('is-removing');
      btn.setAttribute('aria-busy', 'true');
    } else if (btn.matches('.js-qty__adjust--plus, .js-qty__adjust--minus')) {
      const wrapper = btn.closest('.js-qty__selectors') || btn.closest('.js-qty__wrapper');
      if (wrapper) wrapper.classList.add('is-locked');
      btn.classList.add('is-acting');
      btn.setAttribute('aria-busy', 'true');
    }
    _auScheduleSafety();
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches?.('.js-qty__num') && e.target.closest('[data-products]')) {
      beginProcessing();
      _auScheduleSafety();
    }
  });



  document.addEventListener('ajaxProduct:added', (e) => {
    beginProcessing();
    _auWarmCartCache();
  });

  let raf = 0;
  let lastSig = '';
  const cartSig = () => {
    const box = document.querySelector('.cart__items');
    if (!box) return '';
    return [
      box.dataset.count || '',
      box.dataset.cartSubtotal || '',
      box.dataset.cartOriginalSubtotal || '',
      box.dataset.cartPaidSubtotal || '',
    ].join('|');
  };
  const fire = () => {
    bundleProductDDL();
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const sig = cartSig();
      if (sig && sig === lastSig) { endProcessing(); return; }
      if (sig) lastSig = sig;

      _auCancelSafety();
      /* animateBarFill removed — updateMotivationalBar() (called via recompute IIFE)
         already handles fill width, badges, and text. Having both causes flicker. */
      bundleProductDDL();
      syncSubtotal();
      autoFreeGifts();
      _auSyncGiftsOnlyState();
      _auWarmCartCache();
      endProcessing();
    });
  };
  document.querySelectorAll('[data-products]').forEach((el) => {
    new MutationObserver(fire).observe(el, { childList: true });
  });

  document.addEventListener('cart:updated', (e) => {
    bundleProductDDL();
    _auClearActionLock();
  });
}

function main() {
  cartTermsLabelPulse();
  announcementSlider();
  bundleProductDDL();
  syncSubtotal();
  wireCart();
  autoFreeGifts();
  _auSyncGiftsOnlyState();
  _auWarmCartCache();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {

  requestAnimationFrame(main);
  document.addEventListener('DOMContentLoaded', main);
}

window.__auCart = {
  main: main,
  wireCart: wireCart,
  autoFreeGifts: autoFreeGifts,
  autoFreeGiftsFresh: autoFreeGiftsFresh,
};